import script from "./SettingSiteComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingSiteComponent.vue?vue&type=script&setup=true&lang=js"

import "./SettingSiteComponent.vue?vue&type=style&index=0&id=3d5cce1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d5cce1a"]])

export default __exports__